import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { MsalService, MsalGuardConfiguration, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import { BehaviorSubject, catchError, map, Observable, of, tap ,Subject, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IAuthentication } from 'src/models/user/auth.interface';
import { RoleScope } from 'src/models/user/rolescope-interface';
import { TokenStorageService } from './token-storage.service';
import { UtilService } from './util.service';
import { RedirectRequest } from '@azure/msal-browser';



@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private authenticateObservable: Observable<any>;
  private authenticated: boolean;
  private redirectInProcess: boolean;
  public userFullName: string | undefined;
  public userName: string | undefined;

  constructor(@Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration, private http: HttpClient, private tokenStorageService: TokenStorageService, public  msalService: MsalService) {
    this.authenticated = false;
    this.redirectInProcess = false;
    this.authenticateObservable = this.authenticate();
  }

  public authenticate(): Observable<any> {

    let msalService = this.msalService.instance;

    msalService.initialize();

    let accounts = msalService.getAllAccounts();

    if (!accounts || accounts.length == 0) {
      return this.redirect();
    }
    else {
      this.userName = accounts[0].username;
      this.userFullName = accounts[0].name;

      if (!this.userName) {
        return this.redirect();
      }
      else {
        this.userName = this.userName.split("@")[0];
        const authHeader = new HttpHeaders({
          'Authorization': '',
          'AuthenticationToken': environment.AuthenticationToken,
          'UserName': this.userName
        });
        const body = { username: this.userName };
        return this.http.post<any>(environment.apiUrl + '/validateuser', body, {headers:authHeader}).pipe(map((res: IAuthentication) => {
          let retVal = false;
          let bodyres = res;

          if (bodyres && bodyres.userinfoid > 0) {
            let token = bodyres?.token;
            let decodedJWT = JSON.parse(window.atob(token.split('.')[1]));
            let name = decodedJWT["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"];

            if (name != this.userName) {
              return this.redirect();
            }
            if (name != this.userName) {
              return this.redirect();
            }

            this.tokenStorageService.saveToken(bodyres.token);
            this.tokenStorageService.saveUserInfoId(bodyres.userinfoid)
            this.tokenStorageService.saveUserName(<string>this.userName);
            this.tokenStorageService.saveIsSupervisor(bodyres.isSupervisor);
            this.tokenStorageService.saveUserFullName(bodyres.fullName);
            this.tokenStorageService.saveIsAdmin(bodyres.isAdmin);
            this.tokenStorageService.saveIsDeveloper(bodyres.isDeveloper);
            this.tokenStorageService.saveDivId(bodyres.divisionId);
            this.tokenStorageService.saveSecId(bodyres.secid);
            retVal = true;
          }
          return retVal;
        }),
          catchError((e: true | IAuthentication, a: any) => {
            let a2 = this.tokenStorageService.handleError('authenticate', e, a);
            return a;
          }));
      }
    }
  }

  private redirect(): Observable<any> {
    if (!this.redirectInProcess) {
      this.msalService.instance.loginRedirect();
      this.redirectInProcess = true;
    }

    return new Observable<any>(s => s.next(true));
  }

  public getUserName() {
    let accounts = this.msalService.instance.getAllAccounts();
    return accounts[0]?.username.split('@')[0] ?? "";
  }

  public isLoggedIn(): Observable<boolean> {
    
    let accounts = this.msalService.instance.getAllAccounts();
    let loggedIn = new Observable<boolean>(o => {

      if (!accounts || accounts.length == 0) {
        this.login();
      }
      else {
        this.userName = accounts[0].username;
        if (!this.userName) {
          this.redirect();
        }
        else {
          this.userName = this.userName.split("@")[0];
          if (this.authenticated) {
            o.next(true);
          }
          else {
            this.authenticateObservable.subscribe(() => {
              if (this.tokenStorageService.getToken()) {
                o.next(true);
              }
              else {
                o.next(false);
              }
            });
          }
        }
      }
    });
    return loggedIn;
  }

  public login() {
    if (this.msalGuardConfig.authRequest){
      this.msalService.loginRedirect({...this.msalGuardConfig.authRequest} as RedirectRequest);
    } else {
      this.msalService.loginRedirect();
    }
  }

  public logout(): void {
    this.msalService.logoutRedirect({
      postLogoutRedirectUri: location.origin
    });
  }
}
